// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + {"346":"ReferralsPage","375":"BuyBoxPage","789":"LoginPage","824":"FAQPage"}[chunkId] + "." + {"346":"fa502a74","375":"114babcf","789":"1c2b2208","824":"e52b4bfe"}[chunkId] + ".chunk.js";
};